import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { RocketLaunch } from "@mui/icons-material";

const StartNode = memo(({ id, data, isConnectable, selected }) => (
  <NodeWrapper
    id={id}
    data={data}
    icon={<RocketLaunch />}
    title="Inicio"
    subtitle="Ponto inicial do fluxo"
    color="#3aba38"
    bgColor="#F0FFF0"
    noTarget
    isConnectable={isConnectable}
    selected={selected}
  />
));

StartNode.displayName = "StartNode";
export default StartNode;
